export const activityUpdateSchema: any = [];
